import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEmpresaAuth } from '../../../contexts/EmpresaAuthContext';

const EmpresaHome = () => {
  const { empresa } = useEmpresaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (empresa) {
      navigate('/empresa/dashboard');
    } else {
      navigate('/empresa/login');
    }
  }, [empresa, navigate]);

  return <div className="loading">Redirigiendo...</div>;
};

export default EmpresaHome;